import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta({
  startAfterId
}: {
  startAfterId: string;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById(startAfterId);
    if (!target) return;
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      // Show once the first CTA has been scrolled past.
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, [startAfterId]);
  return <div className={`fixed inset-x-0 bottom-0 z-40 px-3 pb-3 transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'}`} data-id="element-131" data-mp="bqsn9eroyi12">
      <a href={CHECKOUT_URL} aria-hidden={!visible} tabIndex={visible ? 0 : -1} className="mx-auto flex min-h-[56px] w-full max-w-md animate-shake items-center justify-center gap-2 rounded-2xl bg-brand-500 px-4 py-3 text-center font-sans text-[14px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_8px_24px_rgba(15,46,28,0.35)] transition-colors duration-150 ease-out hover:bg-brand-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-base" data-id="element-132" data-mp="14ef3bmi3vf4t">
        <span aria-hidden="true" data-id="element-133" data-mp="1wdb08vnvlr1j">🟩</span>
        Voglio il Kit Clinico — €19
      </a>
    </div>;
}